import {SET_ENTERED_OMS} from "./types";

export const setEnteredOms = (enteredOms) => {
    return {
        type: SET_ENTERED_OMS,
        payload: enteredOms
    }
}

export const clearEnteredOms = () => {
    return {
        type: SET_ENTERED_OMS
    }
}